export const LOGIN_SUCCESS = "SIGNUP success";
export const LOGIN_FAILURE = "signup failed";
export const LOGIN_LOADING = "loading SIGNUP";
